// 路由表（原 UniApp navigation.ts 的 vue-router 版本）。
export const routes = {
  home: '/home',
  templates: '/templates',
  detail: '/templates/:id',
  profiles: '/profiles',
  modeling: '/modeling',
  preview: '/preview',
  unlock: '/unlock',
  wallet: '/wallet',
  recharge: '/recharge',
  support: '/support',
  works: '/works',
  account: '/account',
  login: '/login',
}

export const primaryNavigation = [
  { route: 'preview', label: '创作', mark: '✧' },
  { route: 'templates', label: '模板', mark: '◇' },
]

let navigator = null

export function bindNavigator(instance) {
  navigator = instance
}

export function routeUrl(name, params = {}) {
  if (name === 'detail') return `/templates/${encodeURIComponent(params.id || '')}`
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
  return routes[name] + (query ? `?${query}` : '')
}

export function go(name, params = {}) {
  if (!navigator) return
  // 一级入口使用 replace 语义，避免反复点击堆积历史；其余入口正常压栈。
  const primary = primaryNavigation.some((item) => item.route === name)
  if (name === 'detail') navigator.push({ name, params: { id: params.id } }).catch(() => {})
  else if (primary) navigator.replace({ name, query: params }).catch(() => {})
  else navigator.push({ name, query: params }).catch(() => {})
}

export const allowedReturnRoutes = [
  'home',
  'templates',
  'profiles',
  'works',
  'account',
  'preview',
  'unlock',
  'wallet',
  'recharge',
  'support',
  'modeling',
]

export function safeReturn(value) {
  return typeof value === 'string' && allowedReturnRoutes.includes(value) ? value : 'preview'
}

export function loginUrl(returnTo) {
  return `${routes.login}?returnTo=${safeReturn(returnTo)}`
}
